import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type FontSizeOption = 'small' | 'medium' | 'large';

interface FontSizePreset {
  label: string;
  px: number;
}

@Injectable({
  providedIn: 'root'
})
export class FontSizeService {
  private readonly DEFAULT: FontSizeOption = 'medium';

  readonly presets: Record<FontSizeOption, FontSizePreset> = {
    small:  { label: 'Small',  px: 13 },
    medium: { label: 'Medium', px: 15 },
    large:  { label: 'Large',  px: 19 },
  };

  readonly options: FontSizeOption[] = ['small', 'medium', 'large'];

  private selectedSubject: BehaviorSubject<FontSizeOption>;
  selected$;

  constructor() {
    this.selectedSubject = new BehaviorSubject<FontSizeOption>(this.DEFAULT);
    this.selected$ = this.selectedSubject.asObservable();
  }

  get selected(): FontSizeOption {
    return this.selectedSubject.value;
  }

  get currentSize(): number {
    return this.presets[this.selected].px;
  }

  select(option: FontSizeOption): void {
    this.selectedSubject.next(option);
  }
}
